const mRECISTObject = {
    CR: 0,
    PR: 0,
    SD: 0,
    PD: 0,
};

export default mRECISTObject;
